import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_GC_widget_heading]: 'Redeem a Gift Card or Promotion Code',
  [StringId.DV_DP_UB_GC_success_message]: 'Your Amazon gift card or promotional code has been applied.',
  [StringId.DV_DP_DV_GCPC_window_title]: 'Your Balances',
  [StringId.DV_DP_UB_GC_popup_apply]: 'Apply',
  [StringId.DV_DP_UB_GC_enter_code]: 'Enter a New Code',
  [StringId.AVOD_DP_GC_promotion_message]: 'Promotion codes offering a percent-off discount are not reflected in Your Balances.',
  [StringId.DV_DP_GC_balances_explanation]: 'These balances will be automatically applied to any remaining purchase amounts after code redemption.',
  [StringId.AVOD_DP_GC_toc_learn_more]: 'Learn more',
  [StringId.DV_DP_GC_balance_type_heading]: 'Type',
  [StringId.DV_DP_GC_balance_amount_heading]: 'Amount',
  [StringId.DV_DP_GC_code_input_placeholder]: 'Code',
  [StringId.DV_DP_GC_wrong_code]: "The claim code you entered isn't working. Please ensure there are no spaces and try again. If this problem continues, please contact Amazon Customer Service at {link|video_support_website_url}Video Help{end} and refer to error 2039.",
  [StringId.DV_DP_GC_balance_update_failed]: 'Something went wrong updating your balances. Please refresh the page. If this problem continues, please contact Amazon Customer Service at {link|url}Video Help{end} and refer to error 2059',
}
